/* @flow */
import React from 'react';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { getLocationMarkerIcon } from '../../../util/svgImage_util';
import customstyles from './Directions.module.scss';

type Props = {
    directionsDetails: {
        localizedValues: ?Object,
        originLocation: ?Object,
    },
    originAddress?: string,
    onOriginClick?: Function,
}

const DirectionsAttributes = (props : Props) => {
    const { directionsDetails, originAddress, onOriginClick } = props;
    const distance = directionsDetails?.localizedValues?.distance?.text || '';
    const duration = directionsDetails?.localizedValues?.duration?.text || '';
    const latLng = directionsDetails?.originLocation?.latLng;
    const originLocation = (latLng && typeof latLng.latitude === 'number'
        && typeof latLng.longitude === 'number')
        ? { lat: latLng.latitude, lng: latLng.longitude }
        : null;
    const isOriginClickable = typeof onOriginClick === 'function'
        && !!originAddress
        && !!originLocation;
    const handleOriginClick = () => onOriginClick(originLocation, originAddress);
    return (
        <ListItem button className={customstyles['list-item']}>
            <Grid container spacing={0}>
                <Grid item xs={10}>
                    {!!originAddress &&
                        <div // NOSONAR - decorative role kept intentionally
                            className={customstyles['direction-origin-row']}
                            onClick={isOriginClickable ? handleOriginClick : undefined}
                            role="presentation"
                        >
                            <span className={customstyles['direction-origin-pin']}>
                                {getLocationMarkerIcon('A', '#FC0207', false)}
                            </span>
                            <span className={customstyles['direction-origin-address']}>
                                {originAddress}
                            </span>
                        </div>
                    }
                    <Grid container spacing={0} className={customstyles.directionDetailsGrid}>
                        <Grid item xs={12}>
                            <Typography className={customstyles['direction-header']} component="p">
                                <span style={{
                                    color: '#000000',
                                    fontSize: '20px',
                                }}
                                >
                                    Directions Details
                                </span>
                            </Typography>
                            <div style={{ marginTop: '16px' }}>
                                <Typography className={customstyles['direction-header']} component="p">
                                    <span style={{
                                        fontWeight: 'bold',
                                        color: '#000000',
                                        fontSize: '17px',
                                    }}
                                    >
                                        {duration}
                                    </span>
                                    <span style={{
                                        color: '#999999',
                                        marginLeft: '4px',
                                        fontSize: '17px',
                                    }}
                                    >
                                        ({distance})
                                    </span>
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ListItem>
    );
};

export default (DirectionsAttributes);
